<div *ngIf="!p.renderMobile">
  <ion-row class="content">
    <ion-col size="3">
      {{ row.buildingName }}
    </ion-col>
    <ion-col size="3">
      {{ row.companyName }}
    </ion-col>
    <ion-col size="2">
      {{ row.date | dateSti: "onlyDate" }}
    </ion-col>
    <ion-col size="2">
      {{ row.entry }}
    </ion-col>
    <ion-col size="2">
      {{ row.leave }}
    </ion-col>
  </ion-row>
</div>

<ion-card *ngIf="p.renderMobile" class="content-card-noborder">
  <ion-card-header class="guest-layout">
    <ion-grid>
      <ion-row>
        <ion-col size="12">
          <ion-row>
            <ion-col size=1><ion-icon name="home-outline"></ion-icon></ion-col>
            <ion-col size="5">{{ row.buildingName }}</ion-col>
            <ion-col size=1><ion-icon name="business-outline"></ion-icon></ion-col>
            <ion-col size="5">{{ row.companyName }}</ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="line-divider w-100"></div>
  </ion-card-header>
  <ion-card-content>
    <ion-grid>
      <ion-row>
        <ion-col class="center" size="2"><ion-icon name="calendar-outline"></ion-icon></ion-col>
        <ion-col size="10">{{ row.date | dateSti: "onlyDate" }}</ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="center" size="2"><ion-icon name="enter-outline"></ion-icon></ion-col>
        <ion-col size="10">{{ "ADMIN.GUEST_REPORT.ENTRANCES" | translate }}: {{ row.entry }}</ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="center" size="2"><ion-icon name="exit-outline"></ion-icon></ion-col>
        <ion-col size="10">{{ "ADMIN.GUEST_REPORT.EXITS" | translate }}: {{ row.leave }}</ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-content>
</ion-card>